import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { renderField, renderCheckbox, required } from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getApiConfigs} from "../../../actions/actionDevloper";

class ApiFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentApi: {}
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
    }

    submitApi(userData) {
        if (!userData.enabled) {
            userData.enabled = false;
        }
        if (!userData.read_only) {
            userData.read_only = false;
        }
        if (this.props.fromUpdate) {
            userData.api_id = this.state.currentApi && this.state.currentApi.api_id;
            this.props.updateApi(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createApi({api_config: userData})
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateApiError} = this.props;
        if(updateApiError){
            NotificationManager.error(updateApiError,"Create Api", 3000);
        }
        else{
            NotificationManager.success("API Created", "Successfully Created Api");
            this.props.history.push("/developers");
        }
    }

    handleUpdateError(){
        const {updateApiError} = this.props;
        if(updateApiError){
            NotificationManager.error(updateApiError,"Create Api", 3000);
        } else
            NotificationManager.error("Create API Failed","Create Api", 3000);
    }

    handleCreateSuccess(){
        const {createApiError} = this.props;
        if(createApiError){
            NotificationManager.error(createApiError,"Create Api", 3000);
        }
        else{
            NotificationManager.success("API Created", "Successfully Created Api");
            this.props.history.push("/developers");
        }
    }

    handleCreateError(){
        const {createApiError} = this.props;
        if(createApiError){
            NotificationManager.error(createApiError,"Create Api", 3000);
        } else
            NotificationManager.error("Create API Failed","Create Api", 3000);
    }

    cancelButton(){
        this.props.history.push("/developers");
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.apis && nextProps.apis.length > 0 && this.props.apis !== nextProps.apis && this.props.getAPILoading && this.props.fromUpdate){
            let currentApi = nextProps.apis.find(api => api.api_id === this.props.apiId);
            this.setState({currentApi: currentApi});
            this.props.initialize({
                name: currentApi.name,
                enabled: currentApi.enabled,
                read_only: currentApi.read_only,

            });
        }
    }

    componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getApiConfigs();
        }
    }


    render() {
        const {handleSubmit} = this.props;
        const {checked} = this.state;
        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="name"
                                       id="name"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="enabled" className="pull-left">Enabled &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="enabled">
                                    <Field name="enabled"
                                           id="enabled"
                                           checked = {checked}
                                           type ="checkbox"
                                           component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="read_only" className="pull-left">Read Only &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="read_only">
                                    <Field name="read_only"
                                           id="read_only"
                                           checked = {checked}
                                           type ="checkbox"
                                           component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
                        <Button type="cancel" size="sm" color="basic" onClick={() => this.cancelButton()}><i className="fa fa-ban"></i> Cancel</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

ApiFormTemplate.proptypes = {
    createApi: Proptypes.func,
    updateApi: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let ApiFormWithRouter = withRouter(ApiFormTemplate);


let ApiForm =  connect(state =>
        ({
            createApiError: state.develop.createApiError,
            createAPILoading: state.develop.createAPILoading,
            createdApi: state.develop.createdApi,
            updateApiError: state.develop.updateApiError,
            updateAPILoading: state.develop.updateAPILoading,
            updatedApi: state.develop.updatedApi,
            apis: state.develop.apis,
            getAPILoading: state.develop.getAPILoading || false
        }),
    dispatch =>
        ({
            getApiConfigs: () => dispatch(getApiConfigs())
        }))(ApiFormWithRouter);

export default reduxForm({
    form: "ApiForm",
})(ApiForm);


// WEBPACK FOOTER //
// ./src/views/Developers/ApiForm/ApiForm.js